import React, { useState, useEffect, useRef } from "react";

import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { daysFactor, eskalationsLevel } from "./globalVariables";

function ProjektstatusEskalationen({
   color,
   kacheln,
   heading,
   userObjects,
   abschnittsarray,
   showStatusStufen,
   statusLevel,
}) {
   const [show, setShow] = useState(false);
   const [sortedItems, setSortedItems] = useState([]);
   const [maxCounter, setMaxCounter] = useState(1);

   useEffect(() => {
      //{benutzer: bkad, ids: []}
      if (abschnittsarray) {
         let personcounter = {};
         let personmaxdatum = {};

         abschnittsarray.forEach((item) => {
            Object.keys(item.eskalationen).forEach((keyitem) => {
               if (
                  new Date(item.eskalationen[keyitem]) > new Date() ||
                  item.kachelstatus[keyitem] >= eskalationsLevel
               ) {
                  delete item.eskalationen[keyitem];
               } else {
                  if (personmaxdatum[item.benutzer]) {
                     if (personmaxdatum[item.benutzer] > new Date(item.eskalationen[keyitem])) {
                        personmaxdatum[item.benutzer] = new Date(item.eskalationen[keyitem]);
                     }
                  } else {
                     personmaxdatum[item.benutzer] = new Date(item.eskalationen[keyitem]);
                  }
               }
            });

            if (Object.keys(item.eskalationen).length) {
               if (personcounter[item.benutzer] != undefined) {
                  personcounter[item.benutzer].arr.push(item);
                  personcounter[item.benutzer].count += Object.keys(item.eskalationen).length;
                  personcounter[item.benutzer].datum = personmaxdatum[item.benutzer]
                     ? personmaxdatum[item.benutzer]
                     : "";
               } else {
                  personcounter[item.benutzer] = {
                     arr: [item],
                     count: Object.keys(item.eskalationen).length,
                     datum: personmaxdatum[item.benutzer] ? personmaxdatum[item.benutzer] : "",
                     benutzerId: item.benutzer,
                  };
               }
            }
         });

         const sortedpersoncounter = Object.values(personcounter).sort((a, b) => {
            if (a.count < b.count) return 1;
            if (a.count > b.count) return -1;

            return 0;
         });
         if (sortedpersoncounter.length) {
            setMaxCounter(sortedpersoncounter[0].count);
            setSortedItems(sortedpersoncounter);
         }
      }
   }, [abschnittsarray]);

   return (
      <div className="projektstatus-l2">
         {heading && <h2>{heading}</h2>}
         {sortedItems.map((item) => {
            /* console.log(item.benutzerId);
            console.log(item); */
            let maxDays = item.datum ? Math.round((new Date() - item.datum) / 86400000) : 10;

            return (
               <React.Fragment key={"sK_" + item.benutzerId}>
                  <div
                     className={
                        "projektstatus-summe" +
                        (userObjects && userObjects[item.benutzerId] ? "" : " pulsing-background")
                     }
                     style={{
                        backgroundColor: "rgba(200,0,0," + item.count / maxCounter + ")",
                        color: "white",
                     }}
                     onClick={() => setShow(item.benutzerId)}
                  >
                     {userObjects && userObjects[item.benutzerId] ? (
                        <span>
                           {userObjects[item.benutzerId].Vorname + " " + userObjects[item.benutzerId].Nachname}
                        </span>
                     ) : (
                        <span>
                           <strong>OHNE BETREUER</strong>
                        </span>
                     )}
                     <span className="ms-2">
                        {true && item.datum && (
                           <small
                              style={{
                                 // backgroundColor: "#fff",
                                 backgroundColor: `color-mix(in srgb, #f00 ${Math.min((100 * maxDays) / 21, 100)}%, #fff3)`,
                                 color: "#fff",
                                 padding: "2px 8px",
                                 borderRadius: "6px",
                                 marginRight: "8px",
                              }}
                           >
                              {maxDays}
                           </small>
                        )}{" "}
                        {item.count} | <small>{item.arr.length}</small>
                     </span>
                  </div>
                  {userObjects && (
                     <Modal show={show === item.benutzerId} size="lg" onHide={() => setShow(false)}>
                        <Modal.Header closeButton>
                           <Modal.Title>
                              <div className="projekt-statusheading">
                                 <span className="ms-2">
                                    {item.arr.length}{" "}
                                    {item.arr.length > 1 ? "eskalierende Objekte" : "eskalierendes Objekt"}
                                 </span>
                                 {userObjects && userObjects[item.benutzerId] ? (
                                    <span className="ms-2">
                                       von{" "}
                                       {userObjects[item.benutzerId].Vorname +
                                          " " +
                                          userObjects[item.benutzerId].Nachname}
                                    </span>
                                 ) : (
                                    <span className="ms-2">
                                       <strong>OHNE BETREUER</strong>
                                    </span>
                                 )}
                              </div>
                           </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                           <div className="projektstatus-table">
                              {item.arr.map((immo, index) => {
                                 return (
                                    <React.Fragment key={"_" + immo.objektnr_extern}>
                                       <h4 className={index != 0 ? "mt-4" : ""}>
                                          {immo.objektbezeichnung
                                             ? immo.objektbezeichnung
                                             : "Objekt " + immo.objektnr_extern}
                                       </h4>
                                       {Object.keys(immo.eskalationen).map((esk_key) => {
                                          if (kacheln[esk_key]) {
                                             let ablauftage = Math.round(
                                                (new Date() - new Date(immo.eskalationen[esk_key])) / daysFactor,
                                             );
                                             return (
                                                <a
                                                   style={{
                                                      
                                                      backgroundColor: color
                                                         ? `color-mix(in srgb, ${color} 80%, #000)`
                                                         : "#522",
                                                   }}
                                                   key={"aK_" + esk_key}
                                                   target="_blank"
                                                   href={
                                                      "/datenblatt?estateid=" +
                                                      immo.id +
                                                      "&stufe=" +
                                                      kacheln[esk_key].stufenId +
                                                      "&kachel=" +
                                                      kacheln[esk_key].kachelId
                                                   }
                                                >
                                                   {kacheln[esk_key].heading}
                                                   {immo.eskalationen[esk_key] && (
                                                      <small
                                                         title={new Date(
                                                            immo.eskalationen[esk_key],
                                                         ).toLocaleDateString()}
                                                         style={{
                                                            marginLeft: "14px",
                                                            backgroundColor: `color-mix(in srgb, #f00 ${Math.min((100 * ablauftage) / 14, 100)}%, #0009)`,
                                                            padding: "2px 10px",
                                                            borderRadius: "4px",
                                                            position: "absolute",
                                                            right: "20px",
                                                            width: "160px",
                                                            // outline: "solid 1px #f00"
                                                            // boxShadow: "inset 0 0 10px #fff3"
                                                         }}
                                                      >
                                                         {" "}
                                                         seit{" "}
                                                         {ablauftage != 1 ? ablauftage + " Tagen" : ablauftage + " Tag"}
                                                      </small>
                                                   )}
                                                </a>
                                             );
                                          }
                                       })}
                                    </React.Fragment>
                                 );
                              })}
                           </div>
                        </Modal.Body>
                        <Modal.Footer>
                           <Button variant="secondary" onClick={() => setShow(false)}>
                              Schliessen
                           </Button>
                        </Modal.Footer>
                     </Modal>
                  )}
               </React.Fragment>
            );
         })}
      </div>
   );
}
export default ProjektstatusEskalationen;
